import { type FC, useCallback } from 'react'
import { paperClasses } from '@mui/material'

import { GuidedTour, guidedTourClasses, type Tour } from '@dhl/guided-tour'
import { usePostProfileInteractionsName } from '@dhl/receiver-profile-api'
import type { Sx } from '@dhl/theme'

import { useGetGuidedTours } from './useGetGuidedTours.js'
import { isFeatureEnabled } from '~/config/index.js'

// TODO: clean import from mui/material
const guidedTourStyles: Sx = {
  [`& .${guidedTourClasses.step}`]: {
    margin: (theme) => theme.spacing(0, 2),
    [`& .${paperClasses.root}`]: (theme) => ({
      [theme.breakpoints.down('sm')]: {
        width: 'calc(100vw - 32px)',
      },
      [theme.breakpoints.up('sm')]: {
        maxWidth: 342,
        overflow: 'auto',
      },
    }),
  },
}

export const GuidedTourInteraction: FC = () => {
  const { tours } = useGetGuidedTours()
  const { mutate: postCompleteGuidedTour } = usePostProfileInteractionsName()

  const handleTourCompleted = useCallback(
    (tour: Tour) => {
      postCompleteGuidedTour({
        name: tour.name,
      })
    },
    [postCompleteGuidedTour]
  )

  if (!isFeatureEnabled('interaction.guidedTour')) {
    return null
  }

  return (
    <GuidedTour
      active
      documentScrollQuerySelector="#root"
      sx={guidedTourStyles}
      tours={tours}
      onTourCompleted={handleTourCompleted}
    />
  )
}
